import React,{useState,useCallback,FC} from 'react';
import axios from 'axios';
import Select  from 'react-select';
import pako  from 'pako';
import "./ImportconfigurationContainer.scss";

import AppService from '../../../CommonUtils/AppService';
import {PropsType,SelectedConfigType,dropDownStyle} from "./ImportConfigurationContainerTypes";
import { Page,OnlineStatus } from '../../../CommonUtils/Enums';

import { fireAlert } from '../../../CommonUtils/AlertUtils';
import {useRecoilValue,useSetRecoilState} from "recoil";
import { registrationTokenAtom,configurationListAtom,ConfigurationListAtomDefaultValue, pageNameAtom, jsonDataAtom } from '../../../Recoil State/Atoms/PageAtoms';
import { commonPageAtom, spinnerOverlayAtom } from '../../../Recoil State/Atoms/AppAtoms';

export const ImportConfigurationContainer:FC <PropsType> = ( {heading} ) => {

  const registrationTokenState =useRecoilValue(registrationTokenAtom);
  const configurationListState = useRecoilValue(configurationListAtom);
  const jsonDataState = useRecoilValue(jsonDataAtom);

  const configurationListSetter=useSetRecoilState(configurationListAtom);
  const pageNameSetter=useSetRecoilState(pageNameAtom);
  const spinnerOverlaySetter=useSetRecoilState(spinnerOverlayAtom);
  const jsonDataSetter=useSetRecoilState(jsonDataAtom);
  const commonPageSetter = useSetRecoilState(commonPageAtom);

  const[selectedConfig,setSelectedConfig]=useState<SelectedConfigType>({ConfigurationId:0,Name:"Default",label:"Default",value:"Default"});
  const[selectedStatus,setSelectedStatus]=useState<string>(OnlineStatus.Online);

  const handleOptionChange = useCallback((event) => {
    setSelectedStatus(event.target.value);
  },[setSelectedStatus]);

  const importHandler=useCallback(async ()=>{
    const downloadJson = (data) => {
      let json = JSON.stringify(data, null, 2);
      //append extra bytes for security
      let compressedData = MakeRandomChars(2) + compressJsonWithGzip(json)+ MakeRandomChars(2);
      const jsonBlob = new Blob([compressedData], { type: 'application/json' });
      const url = URL.createObjectURL(jsonBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'appinstaller.insjson';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }; 

    const StartDownload= async (downloadISO: (blobUrl, downlodable) => void, spinnerOverlaySetter, blobUrl, downlodable) =>{
      fireAlert({ toast: true, icon: 'success', title: 'File download has started', showConfirmButton: false, timer: 5000, }, {});
      await downloadISO(blobUrl, downlodable);
      spinnerOverlaySetter({
        displayOverlay: false,
        displaySpinner: false,
      });
    }

    const removeTrailingSlash=(url) =>{
      if (url.endsWith('/')) {
        return url.slice(0, -1);
      }
      return url;
    }
    interface Config {
      version: string;
      // Add other properties if present in your config.json
    }
    async function fetchConfig(): Promise<Config | undefined> {
      try {
        const response = await axios.get(removeTrailingSlash(window.location.href) +'/Configurations/config.json');
        const config: Config = response.data;
        return config;
      } catch (error) {
        console.error('Error fetching config.json:', error);
        return undefined;
      }
    }

    const GetDownloadUrl = async () =>{
      let blobUrl: string;
      const config = await fetchConfig();
      let version = config?.version;
      let downlodable = selectedStatus === OnlineStatus.Online ? `IGAppsInstaller_${version}.exe` : `IGAppsInstaller_${version}.ISO`;
      let path = 'Drivers/' + downlodable;
      await axios.post(removeTrailingSlash(window.location.href) + "/downloadblob", { Name: path }, AppService.headerRequestFormat)
        .then((response) => {
          blobUrl = response?.data;
        }).catch(() => {
        });
        
      //devdebug
      //   await axios.post( removeTrailingSlash("https://ig-apim-dev.azure-api.net/AppInstaller") + "/downloadblob", { Name: path },AppService.headerRequestFormat)
      // .then((response)=>{
      // blobUrl = response?.data;
      // }).catch(()=>{
      // }) 

      return { blobUrl, downlodable };
    }
    
    const downloadISO = async (blobUrl, downlodable) => {
      if(blobUrl){
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = downlodable;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        commonPageSetter(false);
        pageNameSetter(Page.DownloadPage);
      } 
      else{
        fireAlert({ toast: true, icon: 'warning', title: 'Installer file unavailable', showConfirmButton: false, timer: 5000, }, {});
      }
    };

    let updatedJsonDataState = JSON.parse(JSON.stringify(jsonDataState));
    spinnerOverlaySetter({
      displayOverlay:true,
      displaySpinner:true,
    })
      updatedJsonDataState.DownloadUrl= removeTrailingSlash(window.location.href) + AppService.BLOB_DOWNLOAD_API;
      //devdebug
      //updatedJsonDataState.DownloadUrl= removeTrailingSlash("https://ig-apim-dev.azure-api.net/AppInstaller") + AppService.BLOB_DOWNLOAD_API;
      updatedJsonDataState.License.LicenseKey=registrationTokenState.registrationKey;

      if(selectedConfig.ConfigurationId!==null && selectedConfig.ConfigurationId!==0)
      {

      AppService.configDetailsRequest={...AppService.configDetailsRequest,"ConfigurationId":selectedConfig.ConfigurationId};

      axios.post(AppService.configDetailsUrl,AppService.configDetailsRequest,AppService.headerRequestFormat)

          .then(async (response)=>{
            let parsedData=JSON.parse(response.data.Details);
            updatedJsonDataState.Configuration=parsedData
            let { blobUrl, downlodable} = await GetDownloadUrl(); 
            updatedJsonDataState.BlobUrl = new URL(blobUrl).origin;
            jsonDataSetter(updatedJsonDataState);
            downloadJson(updatedJsonDataState);
            await StartDownload(downloadISO, spinnerOverlaySetter, blobUrl, downlodable);
          })

          .catch((err)=>{
            spinnerOverlaySetter({
              displayOverlay:false,
              displaySpinner:false,
            })
          })     
      }
      else{
        updatedJsonDataState.Configuration=[];
        let { blobUrl, downlodable} = await GetDownloadUrl(); 
        updatedJsonDataState.BlobUrl = new URL(blobUrl).origin;
        downloadJson(updatedJsonDataState);
        jsonDataSetter(updatedJsonDataState);
        await StartDownload(downloadISO, spinnerOverlaySetter, blobUrl, downlodable);
      }      
  },[selectedConfig,commonPageSetter,jsonDataSetter,jsonDataState,pageNameSetter,registrationTokenState,spinnerOverlaySetter, selectedStatus]);  

  const backButtonHandler=()=>{
    try{
      spinnerOverlaySetter({
        displayOverlay:true,
        displaySpinner:true,
      })
      configurationListSetter(ConfigurationListAtomDefaultValue);

      let updatedJsonDataState = JSON.parse(JSON.stringify(jsonDataState));
      
      updatedJsonDataState.DownloadUrl="";
      updatedJsonDataState.License.LicenseKey="";
      updatedJsonDataState.Configuration=[];
      updatedJsonDataState.Terminal="false";
      updatedJsonDataState.License.Modules=[updatedJsonDataState.License.Modules[0]];

      jsonDataSetter(updatedJsonDataState);

      pageNameSetter(Page.InstallationPreferences);
      spinnerOverlaySetter({
        displayOverlay:false,
        displaySpinner:false,
      })
    }
    catch(err){

    }
  }

  return (
    <div className="import-page">
      <div className="import-page-heading">
        {heading}
      </div>
      <div className="import-page-description">
      Select a configuration from a list of saved configurations for a seamless install experience
      </div>
      <div className="saved-config-container">
      <div className="saved-config-heading">
      Saved Configurations
      </div>
      <div className="dropdown-wrapper">
      <Select options={configurationListState} defaultValue={selectedConfig} 
      onChange={setSelectedConfig} placeholder={<div className="select-placeholder-text">Select a Configuration to import</div>}
      styles={dropDownStyle}/>
      </div>
      <div className="radiobutton-wrapper">
        <form>
        <input type="radio" name="Online" value={OnlineStatus.Online} id="onlineradio" checked={selectedStatus===OnlineStatus.Online} onChange={handleOptionChange}/>
        <label htmlFor="onlineradio">Online Installer</label>
        <input type="radio" name="Ofline" value={OnlineStatus.Offline} id="offineradio" checked={selectedStatus===OnlineStatus.Offline} onChange={handleOptionChange}/>
        <label htmlFor="offineradio">Offline Installer</label>
        </form>        
      </div>
      <div className="import-page-buttons">            
            <button type="button" className="back-button" onClick={backButtonHandler}>Back</button>
            <button type="button" className="import-button" onClick={importHandler}>Download</button>
      </div>
      
      </div>
    </div>
  )
}
const compressJsonWithGzip = (jsonText) => {
  let res;
  try {
    const jsonUint8Array = new TextEncoder().encode(jsonText);
    const compressedData = pako.gzip(jsonUint8Array);
    res = btoa(String.fromCharCode.apply(null, compressedData));
  } catch (error) {
  }
  return res;
}
function MakeRandomChars(length) {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
    counter += 1;
  }
  return result;
}